<template>
    <div class="page-section">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">Kontakt</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <vue-load-image>
          <div slot="image" alt="slight production kontakt slika" class="box-transform" :data-src="require('./../images/kontakt/bg-slight-production-kontakt.jpg')" :style="{ backgroundImage: 'url(' + require('./../images/kontakt/bg-slight-production-kontakt.jpg') + ')' }"></div>
          <div slot="preloader" class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>          
          <div slot="error">učitavam sliku...</div>
        </vue-load-image>         
      </div>        
      <Contact />        
    </div>
</template>

<script>
import Contact from './home/Contact'
export default {
  metaInfo(){
    return{
      title: 'S light production - Javite nam se s punim povjerenjem',
      meta:[
        {
          name: 'description',
          content: 'S light production - Želite li se i Vi uvjeriti u našu kvalitetu i mogućnosti, javite nam se s punim povjerenjem, a mi ćemo Vaše snove pretvoriti u stvarnost i obojiti ih najljepšim bojama.'
        }
      ]
    }
  },  
  components: {
    Contact,
  }
}
</script>

<style lang="scss">
.page{
  section{  
    .shell-fluid{
      max-width: 90%;
      margin: auto;
      .range{
        .news-item{
          max-width:32%;
          padding: 0;
          margin-right: 2%;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .page{
    section{  
      .shell-fluid{
        max-width: 100%;
        margin: auto;
        .range{
          .news-item{
            max-width:49%;
            margin-right: 2%;
            &:nth-child(2n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .page{
    section{  
      .shell-fluid{
        max-width: 100%;
        margin: auto;
        .range{
          .news-item{
            max-width:100%;
            margin-right: 0%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Kontakt.vue